import { StateService } from "@uirouter/angularjs";
import { UserProfile } from "../../../application/UserProfile";
import { ColDef } from "../../grids/columns/colDef";
import { IRowCommandEventArgs } from "../../grids/controller";
import { RecordDataSource } from "../../grids/recordDataSource";
import { IGridSettings } from "../../grids/settings/gridSettingsService";

export class RecordGridViewController {
  static $inject = ["userProfile", "$state"];

  gridDataSource!: RecordDataSource;
  gridSettings: IGridSettings | undefined;
  columns!: ColDef[];
  defaultSort: string | undefined;
  nameSingular: string = "";
  namePlural: string | undefined;
  showAddButton: boolean = false;
  showAddButtonPermission: string | undefined;
  onItemCommand: (args: IRowCommandEventArgs<unknown>) => void = () => {};
  onAddNew!: () => void;

  constructor(
    private readonly userProfile: UserProfile,
    private readonly $state: StateService
  ) {}

  $onInit() {
    if (!this.namePlural) {
      this.namePlural = `${this.nameSingular}s`;
    }
    if (this.onAddNew === undefined) {
      this.onAddNew = () => this.$state.go(".add");
    }
  }

  add() {
    this.onAddNew();
  }

  shouldShowAddButton(): boolean {
    const permission = this.showAddButtonPermission;
    return (
      this.showAddButton &&
      (!permission || this.userProfile.hasPermission(permission))
    );
  }
}
